import { Col } from "react-bootstrap";
import linkIcon from '../assets/img/link_icon.png';

export const ProjectCard = ({ title, description, imgUrl, bigTitle, repositoryLink}) => {
    return (
        <Col sm={6} md={4}>
            <div className="project-image-box">
                <img src={imgUrl} alt="imgUrls" />
                <h5>{bigTitle}</h5>
                <div className="proj-txtx">
                    <h5>{title}</h5>
                    <span>{description}</span>
                        <div className="project-link">
                            {repositoryLink && (
                                <a href={repositoryLink} target="_blank" rel="noopener noreferrer">
                                    <img src={linkIcon} alt="Repository Link"/>
                                </a>
                            )}
                        </div>
                </div>
            </div>
        </Col>
    );
}